import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import config from './config';
import { resolveHashedPath } from './load-translations-utils';
i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
    backend: {
        loadPath: resolveHashedPath,
    },
    lng: config.DEFAULT_LANGUAGE,
    fallbackLng: config.FALLBACK_LANGUAGE,
    supportedLngs: config.LANGUAGES,
    ns: [
        'admin',
        'appointment',
        'barber',
        'calendar',
        'common',
        'customers',
        'engage',
        'reports',
        'settings',
        'shops',
        'auth',
        'splits',
        'subscription',
        'brand',
    ],
    defaultNS: config.DEFAULT_NAMESPACE,
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    debug: process.env.NODE_ENV === 'development',
});
export { i18n };
